import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ChartOfAccountsColumn {
    NAME = "name",
    TYPE = "type",
    SUBTYPE = "subtype",
    DEBIT = "debit",
    CREDIT = "credit",
    BALANCE = "balance",
    SOURCE = "source",
    FORM_1099_BOX = "form1099Box",
    ENTITIES = "entities",
    ACTIONS = "actions",
    // Preview-only: where an account starts (entity / template / both) in the
    // apply-template preview. Never registered in the live CoA view config.
    ORIGIN = "origin",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const TypeColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.TYPE),
});
export type TypeColumn = z.infer<typeof TypeColumnSchema>;

const SubtypeColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.SUBTYPE),
});
export type SubtypeColumn = z.infer<typeof SubtypeColumnSchema>;

const DebitColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.DEBIT),
});
export type DebitColumn = z.infer<typeof DebitColumnSchema>;

const CreditColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.CREDIT),
});
export type CreditColumn = z.infer<typeof CreditColumnSchema>;

const BalanceColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.BALANCE),
});
export type BalanceColumn = z.infer<typeof BalanceColumnSchema>;

const SourceColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.SOURCE),
});
export type SourceColumn = z.infer<typeof SourceColumnSchema>;

const Form1099BoxColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.FORM_1099_BOX),
});
export type Form1099BoxColumn = z.infer<typeof Form1099BoxColumnSchema>;

const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.ENTITIES),
});
export type EntitiesColumn = z.infer<typeof EntitiesColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.ACTIONS),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

const OriginColumnSchema = ColumnSchema.extend({
    id: z.literal(ChartOfAccountsColumn.ORIGIN),
});
export type OriginColumn = z.infer<typeof OriginColumnSchema>;

export const ChartOfAccountsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CHART_OF_ACCOUNTS),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            TypeColumnSchema,
            SubtypeColumnSchema,
            DebitColumnSchema,
            CreditColumnSchema,
            BalanceColumnSchema,
            SourceColumnSchema,
            Form1099BoxColumnSchema,
            EntitiesColumnSchema,
            ActionsColumnSchema,
            OriginColumnSchema,
        ]),
    ),
});

export type ChartOfAccountsView = z.infer<typeof ChartOfAccountsViewSchema>;
